__turbopack_context__.v({
  "active": "AudioGuideButton-module__S-tAlW__active",
  "button": "AudioGuideButton-module__S-tAlW__button",
  "label": "AudioGuideButton-module__S-tAlW__label",
  "loading": "AudioGuideButton-module__S-tAlW__loading",
  "locked": "AudioGuideButton-module__S-tAlW__locked",
  "pulse": "AudioGuideButton-module__S-tAlW__pulse",
  "wrapper": "AudioGuideButton-module__S-tAlW__wrapper",
});
